/**
 * @typedef {object} RoundByRoundState
 * @property {RoundByRoundNavState} nav
 * @property {any} data
 */

/**
 * @typedef {object} RoundByRoundNavState
 * @property {object} competition
 * @property {number|null} competition.id
 * @property {object} season
 * @property {number|null} season.id
 * @property {string|null} season.providerId
 * @property {number} round
 */

/**
 * @typedef {object} RoundByRoundDataRequestDetails
 * @property {string} id
 */
